import { motion } from 'framer-motion';
import { useState } from 'react';

const projects = [
  {
    id: 1,
    title: 'Brand Identity',
    category: 'Branding',
    image: 'https://public.readdy.ai/ai/img_res/e5130fca81dc54239f87249e4076f68c.jpg',
  },
  {
    id: 2,
    title: 'Digital Experience',
    category: 'Web Design',
    image: 'https://readdy.ai/api/search-image?query=elegant%20digital%20interface%20design%20with%20modern%20UI%20elements%2C%20sleek%20web%20application%20mockup%20on%20minimalist%20background%2C%20contemporary%20tech%20aesthetic%2C%20professional%20product%20photography&width=800&height=1000&seq=2&orientation=portrait',
  },
  {
    id: 3,
    title: 'Creative Campaign',
    category: 'Marketing',
    image: 'https://readdy.ai/api/search-image?query=sophisticated%20creative%20marketing%20campaign%20visual%20with%20artistic%20composition%2C%20modern%20advertising%20concept%20on%20clean%20background%2C%20premium%20brand%20aesthetic%2C%20editorial%20photography%20style&width=800&height=1000&seq=3&orientation=portrait',
  },
  {
    id: 4,
    title: 'Product Launch',
    category: 'Strategy',
    image: 'https://readdy.ai/api/search-image?query=premium%20product%20launch%20presentation%20with%20minimalist%20design%20elements%2C%20modern%20tech%20product%20on%20neutral%20backdrop%2C%20high-end%20commercial%20photography%2C%20clean%20studio%20aesthetic&width=800&height=1000&seq=4&orientation=portrait',
  },
];

export default function WorkSection() {
  const [hoveredId, setHoveredId] = useState<number | null>(null);

  return (
    <section id="work" className="py-24 lg:py-32 px-6 lg:px-12 bg-zinc-50">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-16 lg:mb-24"
        >
          <h2
            className="text-5xl sm:text-6xl lg:text-7xl font-light mb-6"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Selected Work
          </h2>
          <p className="text-lg lg:text-xl text-zinc-600 font-light max-w-2xl">
            최신 프로젝트와 크리에이티브 솔루션
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          {projects.map((project, index) => (
            <motion.div
              key={project.id}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              onMouseEnter={() => setHoveredId(project.id)}
              onMouseLeave={() => setHoveredId(null)}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden bg-white mb-6" style={{ height: '500px' }}>
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  style={{ objectPosition: 'top' }}
                />
                <div
                  className={`absolute inset-0 bg-zinc-900/20 transition-opacity duration-500 ${
                    hoveredId === project.id ? 'opacity-100' : 'opacity-0'
                  }`}
                />
              </div>
              <div className="space-y-2">
                <p className="text-sm uppercase tracking-wider text-zinc-500">
                  {project.category}
                </p>
                <h3 className="text-2xl lg:text-3xl font-light">{project.title}</h3>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
